import { Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import { injectReportsHttpApiService } from '@core/reports-contracts';
import { AnalyticsDevFlagsFetchResponse, AnalyticsDevFlagsMap } from '@core/reports-types';

import { buildFlagsMap } from './utils';

@Injectable()
export class AnalyticsDevFlagsHttpClient {
  private readonly httpApi = injectReportsHttpApiService();

  public fetch(): Observable<AnalyticsDevFlagsMap> {
    return this.httpApi
      .get('/features')
      .pipe(map((resp: AnalyticsDevFlagsFetchResponse) => buildFlagsMap(resp.data)));
  }
}
